import { render } from "./StandupPage.vue?vue&type=template&id=5d46cc44&scoped=true"
import script from "./StandupPage.vue?vue&type=script&lang=js"
export * from "./StandupPage.vue?vue&type=script&lang=js"

import "./StandupPage.vue?vue&type=style&index=0&id=5d46cc44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d46cc44"]])

export default __exports__